// @flow
import * as c from './constants';

// eslint-disable-next-line import/prefer-default-export
export const dialogs = (state) => state[c.COMPONENT_NAME];



// WEBPACK FOOTER //
// ./src/common/components/dialog/selectors.js